import axios from "axios";
import { API_BASE_URL } from "config/runtime";

const $AUTH_API = axios.create({
  baseURL: API_BASE_URL,

  headers: {
    "Content-type": "application/x-www-form-urlencoded",
  },
});
export default $AUTH_API;
